import script from "./TablePagination.vue?vue&type=script&lang=ts&setup=true"
export * from "./TablePagination.vue?vue&type=script&lang=ts&setup=true"

import "./TablePagination.vue?vue&type=style&index=0&id=2c7e9992&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c7e9992"]])

export default __exports__